// extracted by mini-css-extract-plugin
module.exports = {"totalPrice":"OrderSummary_totalPrice__iqItL"};